import {
  actionCreator,
  collectRoutines,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import { EMPTY, from } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ArdoqId, ProvenanceSource } from '@ardoq/api-types';
import { RequireAtLeastOne } from '@ardoq/common-helpers';
import { logError } from '@ardoq/logging';
import { launchDeleteComponentsAndReferencesConfirmationDialogByIds } from 'components/Dialogs/confirmDeletion/confirmDeletion';
import { externallyManagedNotice$ } from 'externallyManaged/externallyManagedNotice$';

export type DeleteModelsRequestedPayload = RequireAtLeastOne<{
  componentIds?: ArdoqId[];
  referenceIds?: ArdoqId[];
}> & {
  componentNames?: string[];
  treeSelectionCandidateId?: ArdoqId | null;
  provenanceSource?: ProvenanceSource;
};

export const deleteModelsRequested =
  actionCreator<DeleteModelsRequestedPayload>(
    '[contextMenus] delete models requested'
  );

const handleDeleteModelsRequested = routine(
  ofType(deleteModelsRequested),
  extractPayload(),
  withLatestFrom(externallyManagedNotice$),
  mergeMap(
    ([
      { treeSelectionCandidateId, ...ids },
      { isSuppressed: isExternallyManagedNoticeSuppressed },
    ]) =>
      from(
        launchDeleteComponentsAndReferencesConfirmationDialogByIds({
          ...ids,
          getNextTreeSelectionCandidate: () => treeSelectionCandidateId ?? null,
          isExternallyManagedNoticeSuppressed,
        })
      ).pipe(
        catchError(error => {
          logError(error, 'Failed to delete models from context menu');
          return EMPTY;
        })
      )
  )
);

export const deleteModelsRoutines = collectRoutines(
  handleDeleteModelsRequested
);
